import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import FormInput from '../../../../common/form/Input';
import { RentCafePropertyConfiguration } from '../../../../../api/PropertyIntegration';
// import CheckboxLabeled from '../../../../common/form/CheckboxLabeled';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: RentCafePropertyConfiguration;
    update: (newConfig?: RentCafePropertyConfiguration) => void;
}

const RentCafeConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="RentCafe Configuration"
        cardOpen={!!props.config}
        onCardOpenChange={open => {
            if (isUser)  return;
            props.update(open ? { apiToken: '', companyCode: '', propertyCode: '', propertyId: 0, agent:'', useRentCafeCalendar: true } : undefined)
        }}
    >
        <div>
            {props.config && (
                <>
                    <FormInput
                        labelProps={{
                            labelText: 'Api Token',
                            invalidText: 'Please enter ApiToken'
                        }}
                        inputProps={{
                            id: 'rentCafe-apiToken',
                            name: 'RentCafeApiToken',
                            value: props.config.apiToken,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                apiToken: value.toString()
                            })
                        }
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Company Code',
                            invalidText: 'Please enter Company Code'
                        }}
                        inputProps={{
                            id: 'rentCafe-companyCode',
                            name: 'RentCafeCompanyCode',
                            value: props.config.companyCode,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                companyCode: value.toString()
                            })
                        }
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Property Code',
                            invalidText: 'Please enter Property Code'
                        }}
                        inputProps={{
                            id: 'rentCafe-propertyCode',
                            name: 'RentCafePropertyCode',
                            value: props.config.propertyCode,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                propertyCode: value.toString()
                            })
                        }
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Property Id',
                            invalidText: 'Please enter Property Id'
                        }}
                        inputProps={{
                            id: 'rentCafe-propertyId',
                            name: 'RentCafePropertyId',
                            value: props.config.propertyId,
                            type: 'number',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                propertyId: Number(value)
                            })
                        }
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Agent',
                            invalidText: 'Please enter Agent'
                        }}
                        inputProps={{
                            id: 'rentCafe-agent',
                            name: 'RentCafeAgent',
                            value: props.config.agent,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                agent: value.toString()
                            })
                        }
                    />
                    {/* <CheckboxLabeled
                        labelProps={{
                            labelText:
                                'Use RentCafe Calendar for Tour Scheduling Availability?'
                        }}
                        toggle={true}
                        onChange={() =>
                            props.update({
                                ...props.config!,
                                useRentCafeCalendar: !props.config!.useRentCafeCalendar
                            })
                        }
                        inputProps={{
                            id: 'rentCafe-calendar',
                            name: 'rentCafe-calendar',
                            checked: props.config.useRentCafeCalendar
                        }}
                    /> */}
                </>
            )}
        </div>
    </CollapsibleCard>
);
};
export default RentCafeConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/RentCafeConfigurationSection.tsx